import React, { CSSProperties, useState } from 'react'

import ClickAwayListener from '@mui/material/ClickAwayListener'
import Tooltip from '@mui/material/Tooltip'

import styles from './styles.module.scss'

interface IProps {
  message: string
  src: string
  style?: CSSProperties
}

//Resize
const ToolTipImg: React.FC<IProps> = ({ message, src, style }) => {
  const [open, setOpen] = useState(false)

  const handleTooltipClose = () => {
    setOpen(false)
  }

  const handleTooltipOpen = (event: any) => {
    event.stopPropagation()
    setOpen(true)
  }

  return (
    <>
      <ClickAwayListener onClickAway={handleTooltipClose}>
        <Tooltip
          PopperProps={{
            disablePortal: true,
          }}
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          placement="top"
          title={message}
          arrow
        >
          <button
            type="button"
            onClick={handleTooltipOpen}
            className={styles.warningImgBox}
            style={style}
          >
            <img
              onClick={handleTooltipOpen}
              src={src}
              alt="warning"
              className={styles.warningImg}
            />
          </button>
        </Tooltip>
      </ClickAwayListener>
    </>
  )
}
export default React.memo(ToolTipImg)
